import type { ReactNode } from 'react';
import React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { Label, Table, Tbody, Th, Thead, Tr } from '@itandi/itandi-bb-ui';
import type { Status } from '~/models/Status';
import { NotificationListRow } from '~/components/common/notifications/settings/NotificationListRow';
import type {
  Notification,
  NotificationEdit,
  NotificationTargetType
} from '~/models/Notification';
import type { NskResponse } from '~/models/Api';
import type { Subtype } from '~/models/Subtype';
import type { LineUserAccount } from '~/models/LineUserAccount';

type Props = DeepReadonly<{
  type: NotificationTargetType;
  notifications: Notification[];
  statuses: Status[];
  subtypes?: Subtype[] | null;
  lineUserAccounts?: LineUserAccount[] | null;
  useLineNotification: boolean;
  handleMutate: () => Promise<void>;
  handleUpdate: (
    notification: NotificationEdit,
    notificationId: number
  ) => Promise<NskResponse<void>>;
  handleDestroy: (notification: Notification) => Promise<NskResponse<void>>;
}>;

export const NotificationList: React.FC<Props> = ({
  type,
  notifications,
  statuses,
  subtypes = null,
  lineUserAccounts = null,
  useLineNotification,
  handleMutate,
  handleUpdate,
  handleDestroy
}: Props) => {
  const renderRow = React.useCallback(
    (notification: Notification): ReactNode => (
      <NotificationListRow
        key={notification.id}
        handleDestroy={handleDestroy}
        handleMutate={handleMutate}
        handleUpdate={handleUpdate}
        lineUserAccounts={lineUserAccounts}
        notification={notification}
        statuses={statuses}
        subtypes={subtypes}
        type={type}
        useLineNotification={useLineNotification}
      />
    ),
    [
      handleDestroy,
      handleMutate,
      handleUpdate,
      lineUserAccounts,
      statuses,
      subtypes,
      type,
      useLineNotification
    ]
  );
  return (
    <Table>
      <Thead>
        <Tr>
          <Th>
            <Label weight="bold">案件種別</Label>
          </Th>
          <Th>
            <Label weight="bold">通知トリガー</Label>
          </Th>
          <Th>
            <Label weight="bold">案件状況</Label>
          </Th>
          <Th>
            <Label weight="bold">通知タイプ</Label>
          </Th>
          <Th>
            <Label weight="bold">通知先</Label>
          </Th>
          <Th>
            <Label weight="bold">通知タイトル</Label>
          </Th>
          <Th width="6rem">
            <Label weight="bold">操作</Label>
          </Th>
        </Tr>
      </Thead>
      <Tbody>{notifications.map(renderRow)}</Tbody>
    </Table>
  );
};
